import React, { useCallback } from 'react'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import Marker from '../../map/markers/Marker'
import sItineraryCommon from '../itinerary-commons.less'
import classnames from 'classnames'

import { useAction } from '../../utils/react-redux'
import { setDepartureFromPoint, setStepFromPoint } from '../../../store/itinerary/itinerary.actions'
import { TAG_DRAG_AND_DROP } from '../../analytics/analytics.tagids.constants'
import { ACTION } from '../../analytics/ClickTagsService'
import analyticsConstants from '../../analytics/analytics.constants'

export default function DepartureMarker({ coords: { lng, lat }, step, stepIdx }) {
  const execSetDepartureFromPoint = useAction(setDepartureFromPoint)
  const execSetStepFromPoint = useAction(setStepFromPoint)
  const configureAndSendTag = useConfigureAndSendTag()

  const onDragEnd = useCallback(event => {
    const position = event?.target?._lngLat

    if (!position) return

    if (step) {
      execSetStepFromPoint(position, stepIdx)
    } else {
      execSetDepartureFromPoint(position)
    }

    configureAndSendTag({
      type: TAG_DRAG_AND_DROP,
      tagInfo: {
        [ACTION]: step
          ? analyticsConstants.itinerary.dragndrop.action.step
          : analyticsConstants.itinerary.dragndrop.action.departure
      }
    })
  }, [])

  return (
    <Marker
      key={`${lng}_${lat}`}
      coordinates={{ lng, lat }}
      anchorPosition="center"
      dragOptions={{
        onDragEnd
      }}
    >
      <div className={classnames(sItineraryCommon.itineraryDepartureIcon, step && sItineraryCommon.stepMarker)} />
    </Marker>
  )
}
